import { jsx as _jsx } from "react/jsx-runtime";
import '@styles/webdesktop/stylesheets/expandCollapseArrow.scss';
import { Resources } from '@shared/localizations/Resources';
import { SvgIcon } from '../SvgIcon/SvgIcon';
import { SvgIconType } from '../SvgIcon/SvgIconType';
export var ArrowPanelType;
(function (ArrowPanelType) {
    ArrowPanelType["OrderEntry"] = "order-entry";
    ArrowPanelType["SideBar"] = "sidebar";
})(ArrowPanelType || (ArrowPanelType = {}));
export const ExpandCollapseArrow = ({ isExpanded = false, isButton = false, type = ArrowPanelType.SideBar, highlightSelected = false, onClick }) => {
    const className = [
        'expand-collapse-button',
        isExpanded ? 'expanded' : 'collapsed',
        type === ArrowPanelType.OrderEntry ? 'oe' : '',
        highlightSelected && isExpanded ? 'highlight' : ''
    ]
        .filter(Boolean)
        .join(' ');
    const expandedIcon = type === ArrowPanelType.SideBar ? SvgIconType.ArrowDown : SvgIconType.ArrowLeft;
    const svgIcon = _jsx(SvgIcon, { icon: isExpanded ? expandedIcon : SvgIconType.ArrowRight });
    if (isButton) {
        return (_jsx("button", { className: className, onClick: onClick, "aria-expanded": isExpanded, "aria-label": isExpanded ? Resources.getResource('property.Collapse') : Resources.getResource('property.Expand'), children: svgIcon }));
    }
    else {
        return _jsx("div", { className: className, children: svgIcon });
    }
};
